$('.custom-product-page-faq-accordion .accordion__block-content .show-hide').click(function(){
  if($(this).hasClass('shown')){
    $(this).removeClass('shown');
    $(this).text("See more...")
    var getParent = $(this).parent();
    $(getParent).find(".hide-content").hide(500);
  }
  else{
    $(this).addClass('shown');
    $(this).text("See less...")
    var getParent = $(this).parent();
    $(getParent).find(".hide-content").show(500);
  }
});

// $('.custom-product-page-faq-accordion .accordion__block-content .shown').click(function(){
//   $(this).removeClass('shown');
//   var getParent = $(this).parent();
//   $(getParent).find("p").show(300);
// });